/**
 * 文档状态码
 */
export var DOC_STATUS = /*#__PURE__*/function (DOC_STATUS) {
  DOC_STATUS[DOC_STATUS["docStatusNormal"] = 0] = "docStatusNormal";
  DOC_STATUS[DOC_STATUS["docStatusDelete"] = 1] = "docStatusDelete";
  DOC_STATUS[DOC_STATUS["docStatusTrash"] = 2] = "docStatusTrash";
  DOC_STATUS[DOC_STATUS["docStatusHidden"] = 3] = "docStatusHidden";
  DOC_STATUS[DOC_STATUS["docStatusTrans"] = 4] = "docStatusTrans";
  DOC_STATUS[DOC_STATUS["docStatusImport"] = 5] = "docStatusImport";
  DOC_STATUS[DOC_STATUS["docStatusChecking"] = 6] = "docStatusChecking";
  DOC_STATUS[DOC_STATUS["docStatusForbidden"] = 7] = "docStatusForbidden";
  DOC_STATUS[DOC_STATUS["docStatusImportFailed"] = 8] = "docStatusImportFailed";
  DOC_STATUS[DOC_STATUS["docStatusCopy"] = 9] = "docStatusCopy";
  DOC_STATUS[DOC_STATUS["docStatusCopyFailed"] = 10] = "docStatusCopyFailed";
  DOC_STATUS[DOC_STATUS["docStatusPrepare"] = 11] = "docStatusPrepare";
  DOC_STATUS[DOC_STATUS["docStatusHiddenUntilModify"] = 12] = "docStatusHiddenUntilModify";
  DOC_STATUS[DOC_STATUS["docStatusFileUploading"] = 13] = "docStatusFileUploading";
  return DOC_STATUS;
}({});

/**
 * 文档基本信息
 */
//# sourceMappingURL=doc-pad-info.interface.js.map